import util from "../../../util";

export { Analytics } from "../../js/Analytics";
export class CannabisShowcaseAnalytics {
    static makeMosaicEventProperties(item) {
        let tier = "";

        switch (Number(item.featured_type || item.featured_type_varchar)) {
            case 16323:
                tier = "Regular ";
                break;
            case 16322:
                tier = "Premium ";
                break;
            default:
                tier = "";
                break;
        }

        return {
            action: "Cannabis Showcase " + tier + "Mosaic_" + item.name,
            label: `${window.location.origin}/item/${util.convertToUrlKey(item.name)}/${item.sku}`,
            value: item.sku, // TODO(trevor) Need to figure out what value we want here, banners use io_number
            seller: {
                id: item.seller_id,
                name: item.seller_name
            }
        };
    }

    static makeInformationEventProperties(action_prefix, item, link) {
        return {
            action: action_prefix + item.name,
            label: link,
            value: item.sku,
            seller: {
                id: item.seller_id,
                name: item.seller_name
            }
        };
    }
}
